
import authRules from '../authRules';

const resourceInfoSSO = (user) => {
  const { resourceInfoSSO } = user.securityLevels;
  if (resourceInfoSSO >= authRules.resourceInfoSSO.resourceInfoSSO) {
    return true;
  } else {
    return false;
  }
}

export default resourceInfoSSO;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/resourceInfoSSO.js